/**
 * Detects the non-actionable "Params are not set" browser error that surfaces
 * on iOS Safari when navigating to portal pages with query-string parameters
 * (e.g. `/portal/appointments?userId=123`).
 *
 * The error has no stack frames, no referrer, and does not originate from
 * application source code — it cannot be reproduced or debugged. Suppressing
 * it keeps Datadog error tracking focused on actionable issues.
 */
export const isStacklessParamsNotSetError = (
  message: string | undefined,
  stack: string | undefined,
): boolean => {
  if (message !== "Params are not set") {
    return false;
  }

  if (!stack || stack === "Error: Params are not set") {
    return true;
  }

  const frames = stack.split("\n").filter((l) => l.trim().startsWith("at "));
  return frames.length === 0;
};
